// Modules
import React from "react";

const BathMatIcon = (props) => {
	return (
		<svg
			height="1em"
			viewBox="0 0 512 512"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g>
				<g>
					<g>
						<path d="M88.453,173.795c-4.156,4.156-4.156,10.906,0,15.078c4.172,4.171,10.921,4.171,15.093,0
				c4.156-4.172,4.156-10.922,0-15.078C99.374,169.623,92.624,169.623,88.453,173.795z"/>
						<path d="M173.795,173.795c-4.172,4.156-4.172,10.906,0,15.078c4.156,4.171,10.906,4.171,15.078,0
				c4.171-4.172,4.171-10.922,0-15.078C184.702,169.623,177.952,169.623,173.795,173.795z"/>
						<path d="M259.123,173.795c-4.172,4.156-4.172,10.906,0,15.078c4.172,4.171,10.922,4.171,15.078,0
				c4.172-4.172,4.172-10.922,0-15.078C270.045,169.623,263.295,169.623,259.123,173.795z"/>
						<path d="M45.797,216.45c-4.172,4.172-4.172,10.922,0,15.094c4.156,4.156,10.906,4.156,15.078,0
				c4.172-4.172,4.172-10.922,0-15.094C56.703,212.294,49.953,212.294,45.797,216.45z"/>
						<path d="M88.453,259.122c-4.156,4.156-4.156,10.922,0,15.078c4.172,4.172,10.921,4.172,15.093,0
				c4.156-4.156,4.156-10.922,0-15.078C99.374,254.95,92.624,254.95,88.453,259.122z"/>
						<path d="M131.124,216.45c-4.172,4.172-4.172,10.922,0,15.094c4.172,4.156,10.922,4.156,15.078,0
				c4.172-4.172,4.172-10.922,0-15.094C142.046,212.294,135.296,212.294,131.124,216.45z"/>
						<path d="M173.795,259.122c-4.172,4.156-4.172,10.922,0,15.078c4.156,4.172,10.906,4.172,15.078,0
				c4.171-4.156,4.171-10.922,0-15.078C184.702,254.95,177.952,254.95,173.795,259.122z"/>
						<path d="M216.451,216.45c-4.156,4.172-4.156,10.922,0,15.094c4.172,4.156,10.922,4.156,15.094,0
				c4.156-4.172,4.156-10.922,0-15.094C227.373,212.294,220.623,212.294,216.451,216.45z"/>
						<path d="M259.123,259.122c-4.172,4.156-4.172,10.922,0,15.078c4.172,4.172,10.922,4.172,15.078,0
				c4.172-4.156,4.172-10.922,0-15.078C270.045,254.95,263.295,254.95,259.123,259.122z"/>
						<path d="M301.793,216.45c-4.172,4.172-4.172,10.922,0,15.094c4.156,4.156,10.906,4.156,15.078,0
				c4.172-4.172,4.172-10.922,0-15.094C312.699,212.294,305.949,212.294,301.793,216.45z"/>
						<path d="M45.797,301.794c-4.172,4.156-4.172,10.906,0,15.078c4.156,4.172,10.906,4.172,15.078,0s4.172-10.922,0-15.078
				C56.703,297.622,49.953,297.622,45.797,301.794z"/>
						<path d="M88.453,344.448c-4.156,4.172-4.156,10.922,0,15.094c4.172,4.156,10.921,4.156,15.093,0
				c4.156-4.172,4.156-10.922,0-15.094C99.374,340.292,92.624,340.292,88.453,344.448z"/>
						<path d="M131.124,301.794c-4.172,4.156-4.172,10.906,0,15.078c4.172,4.172,10.922,4.172,15.078,0
				c4.172-4.172,4.172-10.922,0-15.078C142.046,297.622,135.296,297.622,131.124,301.794z"/>
						<path d="M173.795,344.448c-4.172,4.172-4.172,10.922,0,15.094c4.156,4.156,10.906,4.156,15.078,0
				c4.171-4.172,4.171-10.922,0-15.094C184.702,340.292,177.952,340.292,173.795,344.448z"/>
						<path d="M216.451,301.794c-4.156,4.156-4.156,10.906,0,15.078c4.172,4.172,10.922,4.172,15.094,0
				c4.156-4.172,4.156-10.922,0-15.078C227.373,297.622,220.623,297.622,216.451,301.794z"/>
						<path d="M259.123,344.448c-4.172,4.172-4.172,10.922,0,15.094c4.172,4.156,10.922,4.156,15.078,0
				c4.172-4.172,4.172-10.922,0-15.094C270.045,340.292,263.295,340.292,259.123,344.448z"/>
						<path d="M301.793,301.794c-4.172,4.156-4.172,10.906,0,15.078c4.156,4.172,10.906,4.172,15.078,0s4.172-10.922,0-15.078
				C312.699,297.622,305.949,297.622,301.793,301.794z"/>
						<path d="M45.797,387.12c-4.172,4.172-4.172,10.922,0,15.078c4.156,4.172,10.906,4.172,15.078,0
				c4.172-4.156,4.172-10.906,0-15.078S49.953,382.948,45.797,387.12z"/>
						<path d="M88.453,429.792c-4.156,4.156-4.156,10.906,0,15.078c4.172,4.172,10.921,4.172,15.093,0
				c4.156-4.172,4.156-10.922,0-15.078C99.374,425.62,92.624,425.62,88.453,429.792z"/>
						<path d="M344.449,173.795c-4.156,4.156-4.156,10.906,0,15.078c4.172,4.171,10.922,4.171,15.094,0
				c4.156-4.172,4.156-10.922,0-15.078C355.371,169.623,348.621,169.623,344.449,173.795z"/>
						<path d="M344.449,259.122c-4.156,4.156-4.156,10.922,0,15.078c4.172,4.172,10.922,4.172,15.094,0
				c4.156-4.156,4.156-10.922,0-15.078C355.371,254.95,348.621,254.95,344.449,259.122z"/>
						<path d="M344.449,344.448c-4.156,4.172-4.156,10.922,0,15.094c4.172,4.156,10.922,4.156,15.094,0
				c4.156-4.172,4.156-10.922,0-15.094C355.371,340.292,348.621,340.292,344.449,344.448z"/>
						<path d="M344.449,429.792c-4.156,4.156-4.156,10.906,0,15.078c4.172,4.172,10.922,4.172,15.094,0
				c4.156-4.172,4.156-10.922,0-15.078C355.371,425.62,348.621,425.62,344.449,429.792z"/>
						<path d="M131.124,387.12c-4.172,4.172-4.172,10.922,0,15.078c4.172,4.172,10.922,4.172,15.078,0
				c4.172-4.156,4.172-10.906,0-15.078C142.046,382.948,135.296,382.948,131.124,387.12z"/>
						<path d="M173.795,429.792c-4.172,4.156-4.172,10.906,0,15.078c4.156,4.172,10.906,4.172,15.078,0
				c4.171-4.172,4.171-10.922,0-15.078C184.702,425.62,177.952,425.62,173.795,429.792z"/>
						<path d="M216.451,387.12c-4.156,4.172-4.156,10.922,0,15.078c4.172,4.172,10.922,4.172,15.094,0
				c4.156-4.156,4.156-10.906,0-15.078C227.373,382.948,220.623,382.948,216.451,387.12z"/>
						<path d="M259.123,429.792c-4.172,4.156-4.172,10.906,0,15.078c4.172,4.172,10.922,4.172,15.078,0
				c4.172-4.172,4.172-10.922,0-15.078C270.045,425.62,263.295,425.62,259.123,429.792z"/>
						<path d="M301.793,387.12c-4.172,4.172-4.172,10.922,0,15.078c4.156,4.172,10.906,4.172,15.078,0
				c4.172-4.156,4.172-10.906,0-15.078S305.949,382.948,301.793,387.12z"/>
						<path d="M429.793,429.792c-4.172,4.156-4.172,10.906,0,15.078c4.156,4.172,10.906,4.172,15.078,0s4.172-10.922,0-15.078
				C440.699,425.62,433.949,425.62,429.793,429.792z"/>
						<path d="M447.996,21.327c-35.297,0-64,28.719-64,64v42.671H10.672C4.781,127.998,0,132.779,0,138.67v341.325
				c0,5.891,4.781,10.672,10.672,10.672h437.23c0.031,0,0.062,0,0.094,0c35.279,0,63.998-28.719,63.998-64V85.327
				C511.994,50.046,483.275,21.327,447.996,21.327z M448.043,469.323c-0.016,0-0.047,0-0.078,0H21.328V149.326h362.668v277.341
				c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656c0-23.531,19.141-42.672,42.672-42.672
				s42.67,19.141,42.67,42.672C490.666,450.167,471.559,469.308,448.043,469.323z M490.666,378.995
				c-11.326-10.156-26.295-16.328-42.67-16.328c-16.375,0-31.344,6.172-42.672,16.328V85.327c0-23.516,19.141-42.656,42.672-42.656
				s42.67,19.141,42.67,42.656V378.995z"/>
					</g>
				</g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
			<g>
			</g>
		</svg>
	);
};

export default BathMatIcon;
